import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import Datetime from 'react-datetime'
export default function Dashboard() {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        let com_id = localStorage.getItem('mem_company_id');
        console.log(com_id);
    }, [])

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (

        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                <div className='vl_dsh_one_block'>
                                    <div className='vl_dsh_one_half'><h2>Project overview </h2></div>
                                    <div className='vl_dsh_one_half'><Link className='linkbutton vl_align_right' to="/create_projects">Create A Project</Link></div>
                                    <div className='vl_dsh_one_full'><p>You have 5 active projects</p></div>
                                    <div className='vl_dsh_one_table'>
                                        <table>
                                            <tr>
                                                <th className='text_left pd-tb-15'>Project</th>
                                                <th className='text_left pd-tb-15'>Start</th>
                                                <th className='text_left pd-tb-15'>Deadline</th>
                                                <th className='text_left pd-tb-15'>Status</th>
                                                <th className='text_left pd-tb-15'>Progress</th>
                                            </tr>
                                            <tbody>
                                                <tr >
                                                    <td className='pd-tb-15'>Grovan Management</td>
                                                    <td className='pd-tb-15'>12.01.25</td>
                                                    <td className='pd-tb-15'>23.05.25</td>
                                                    <td className='pd-tb-15'>Behind</td>
                                                    <td className='pd-tb-15'>30%</td>
                                                </tr>
                                                <tr className='pd-tb-10'>
                                                    <td className='pd-tb-15'>Gulf Charm</td>
                                                    <td className='pd-tb-15'>19.12.24</td>
                                                    <td className='pd-tb-15'>23.09.25</td>
                                                    <td className='pd-tb-15'>before</td>
                                                    <td className='pd-tb-15'>45%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_half'>
                                <div className='vl_dsh_one_block'>
                                    <div className='vl_dsh_one_full'><h2>Inbox overview </h2></div>
                                    <div className='vl_dsh_one_full'><p>You have 5 unread message</p></div>
                                    <div className='vl_dsh_one_table'>
                                        <table>
                                            <tr>
                                                <th className='text_left pd-tb-15'>Subject</th>
                                                <th className='text_left pd-tb-15'>Sender</th>
                                                <th className='text_left pd-tb-15'>Date</th>
                                                <th className='text_left pd-tb-15'>Status</th>
                                                <th className='text_left pd-tb-15'>Action</th>
                                            </tr>
                                            <tbody>
                                                <tr >
                                                    <td className='pd-tb-15'>New feedback</td>
                                                    <td className='pd-tb-15'>Alex</td>
                                                    <td className='pd-tb-15'>03.02.25</td>
                                                    <td className='pd-tb-15'>Unread</td>
                                                    <td className='pd-tb-15'><Link className='linktext' to="">Read Now</Link></td>
                                                </tr>
                                                <tr className='pd-tb-10'>
                                                    <td className='pd-tb-15'>Project Complete</td>
                                                    <td className='pd-tb-15'>Groven Team</td>
                                                    <td className='pd-tb-15'>08.02.25</td>
                                                    <td className='pd-tb-15'>Unread</td>
                                                    <td className='pd-tb-15'><Link className='linktext' to="">Read Now</Link></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className='vl_dsh_one_half'>
                                <div className='vl_dsh_one_block'>
                                    <div className='vl_dsh_one_half'>
                                        <div className='vl_dsh_one_full'><h2 className='fullwidth'>Time Tracking </h2></div>
                                        <div className='vl_dsh_one_full'><h3>Last Day's Report</h3></div>
                                        <div className='vl_dsh_one_full'><p>Total Hours Worked : 89 Hrs<br></br>Total Target Hours: 80 Hrs<br></br>Total Extra Hours : 9 Hrs</p></div>
                                        <div className='vl_dsh_one_full'><Link to=''>View More</Link></div>
                                    </div>
                                    <div className='vl_dsh_one_half'>
                                        <p>You can generate a complete Time Tracking report By click on the  quick report button below.</p>
                                        <div className='fullwodth mtb-15 pull_left'><Link className='linkbutton' to="">Generate Report</Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full'>
                                <div className='vl_dsh_one_block noborder nopadding'>
                                    <div className='vl_dsh_conv_bar'>
                                        <h2>Arrange a meeting</h2>
                                        <p>Arrange a general meeting and send notification to all of your team member by selecting the date and time. If you want to arrange the meeting with some perticular team member then go to the meeting room and send notification for meeting to selected members only.</p>
                                        <div className='vl_dsh_one_row'>
                                            <div className='vl_dsh_one_third'>
                                                <div className='meeting_schdule'>
                                                    <Datetime inputProps={{ placeholder: 'Select Date and Time' }} />
                                                </div>

                                            </div>
                                            <div className='vl_dsh_two_third'>
                                                <h3 className='vl_dsh_subheading'>Insert details of the meeting</h3>
                                                <div className='vl_dsh_formnholder'>
                                                    <div className='formfield'>
                                                        <input type="text" placeholder='Meeting Title' id="meeting_title" />
                                                    </div>
                                                    <div className='formfield'>
                                                        <textarea placeholder='Meeting Details' id="meeting_details"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='vl_dsh_ove_full'>
                                                <div className='vl_dsh_buttonholder'>
                                                    <button className='btn btn-primary_gap'>Send Notice</button>
                                                    <button className='btn btn-primary'>Or Go To Meeting Room</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    '
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
